import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function BookingTypesNavIcon() {
  return <SvgIcon viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="17" rx="3" />
      <path d="M8 2v4m8-4v4M4 10h16m-11 5h6" />
    </g>
  </SvgIcon>;
}

export function CalendarNavIcon() {
  return <SvgIcon viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="17" rx="3" />
      <path d="M8 2v4m8-4v4M3 10h18m-13 4h1m6 0h1m-8 3h1m6 0h1" />
    </g>
  </SvgIcon>;
}
